<!--
 * @Author:
 * @LastEditTime: 2026-01-23 14:28:26
 * @Description:
-->
<template>
  <div class="w-full h-full">
    <!-- 顶部 -->
    <div class="absolute z-9 w-full flex justify-between items-center h-80px training-header">
      <div class="h-full flex-1 relative" v-for="item in headerImgs" :key="item.key">
        <span
          v-if="item.text"
          class="text-white text-2xl font-bold absolute top-2/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 header-text"
          >{{ item.text }}</span
        >
        <img :src="item.src" alt="" class="h-full w-full" />
      </div>
    </div>
    <div
      class="left-control absolute"
      :class="showModelTree ? 'openTree' : ''"
      @click="showModelTree = !showModelTree"
    ></div>
    <div
      class="right-control absolute"
      v-if="isShowStep"
      :class="isOpenStep ? 'openStep' : ''"
      @click="
        isOpenStep = !isOpenStep
        showTagBasicInfo = false
      "
    ></div>
    <!-- <el-tooltip effect="dark" content="位号基本信息" placement="bottom">
      <div
        class="right-control absolute right-control1"
        :class="showTagBasicInfo ? 'openStep' : ''"
        @click="
          showTagBasicInfo = !showTagBasicInfo
          isOpenStep = false
        "
      ></div>
    </el-tooltip> -->
    <div class="tips absolute text-white" v-if="showTips">
      <div class="tips-content">
        <div class="scheme-name">方案名称：{{ schemeDetail.name }}</div>
        <div class="text-white">操作模式：{{ operateTypeList[operateType] }}</div>
      </div>
    </div>
    <!-- 消息 -->
    <div
      class="w-800px h-200px absolute left-30px bottom-20px z-98"
      v-if="isShowMsg && msgList.length > 0"
    >
      <div
        v-for="(item, index) in limitedMsgList"
        :key="`${index}-${item.code}`"
        :class="{
          'flash-message': index === limitedMsgList.length - 1 && item.type === 'msg',
          'flash-warn': index === limitedMsgList.length - 1 && item.type === 'warn',
          'text-black': item.type === 'msg',
          'text-red-600': item.type === 'warn',
          'text-green-500': item.type === 'success',
        }"
      >
        {{ item.msg }}
      </div>
    </div>
    <!-- 返回按钮 -->
    <div
      class="z-998 btn cursor-pointer w-100px h-35px absolute right-1/50 top-1/20"
      @click="goBack"
    >
      返回
    </div>
    <div
      class="operate-button absolute flex"
      v-if="showOperateSpeed && (operateType === 0 || operateType === 1)"
    >
      <el-tooltip effect="dark" content="播放" placement="bottom">
        <div class="play" @click="operateSpeed('play')"></div>
      </el-tooltip>
      <el-tooltip effect="dark" content="暂停" placement="bottom">
        <div class="pause" @click="operateSpeed('pause')"></div>
      </el-tooltip>
      <el-tooltip effect="dark" content="慢放" placement="bottom">
        <div class="slow" @click="operateSpeed('slow')"></div>
      </el-tooltip>
      <el-tooltip effect="dark" content="速度" placement="bottom">
        <div class="speed flex text-white fz-18">{{ showSpeed }}X</div>
      </el-tooltip>
      <el-tooltip effect="dark" content="快进" placement="bottom">
        <div class="fast" @click="operateSpeed('fast')"></div>
      </el-tooltip>
      <el-tooltip effect="dark" content="重置速度" placement="bottom">
        <div class="reset" @click="operateSpeed('reset')"></div>
      </el-tooltip>
    </div>
    <div class="finish-mask absolute" v-if="showFinish">
      <div class="finish absolute">
        <div
          class="text-25px mt-20px mb-15px flex justify-center items-center text-white finish-title"
        >
          完成{{ operateText }}
        </div>
        <div class="content fz-20">恭喜你完成了当前的{{ operateText }}方案</div>
        <div class="w-full flex justify-center mt-35px operate">
          <el-button @click="goBack">返回列表</el-button>
          <el-button @click="operateAgain">再次操作</el-button>
          <el-button @click="showFinish = false">取消</el-button>
        </div>
      </div>
    </div>
    <ModelViewVulkan
      v-if="!_.isEmpty(sceneOptions)"
      :sceneOptions="sceneOptions"
      :code="currentCode"
      :cloudRender="cloudRender"
      @sendPlayer="sendPlayer"
      @modelClick="modelClick"
      @loadSceneEnd="loadModelEnd"
    ></ModelViewVulkan>
    <!-- 模型树 -->
    <ModelTree
      :player="player"
      v-if="showModelTree"
      @doLocation="modelClick"
      class="model-tree"
    ></ModelTree>
    <!-- 选择方案执行类型 -->
    <SelectAction
      :schemeDetail="schemeDetail"
      @executeScheme="executeScheme(arguments)"
      v-if="showSelect"
      :showSelect.sync="showSelect"
    ></SelectAction>
    <!-- 步骤列表-->
    <PlayStepList
      ref="stepRef"
      :player="player"
      v-show="player && isOpenStep && isShowStep"
      :steps="steps"
      :currentStepIndex="currentStepIndex"
      :operateType="operateType"
      :isAssessMode="isAssessMode"
      :isShowMsg="isShowMsg"
      :showJump="showJump"
      @stepJump="stepJump"
    ></PlayStepList>
    <!--<BitRelational
      :player="player"
      :tagCode="currentCode"
      :location="location"
      :fileId="modelParams.fileId"
      v-show="showTagBasicInfo"
      ref="BitRelational"
      @closeComponent="showTagBasicInfo = false"
      :isSingleUse="true"
    >
    </BitRelational> -->
  </div>
</template>
<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import { instance as cloudRender } from 'wiz-cloud-render-vulkan'
import { ModelSceneApi } from '@wiz-api/scene-management'
import {
  EquipDisAssembleyLearnRecordApi,
  EquipDisAssembleySolutionApi,
} from '@wiz-api/equipment-assembly-trainning'

const equipDisAssembleyLearnRecord = new EquipDisAssembleyLearnRecordApi()
const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()
const modelSceneApi = new ModelSceneApi()
const ModelViewVulkan = () => {
  return import('@/components/model-vulkan/ModelViewVulkan')
}
const ModelTree = () => {
  return import('@/components/model-vulkan/ModelTreeVulkan')
}
const SelectAction = () => {
  return import('../components/SelectAction')
}
const PlayStepList = () => {
  return import('../components/PlayStepList')
}
export default {
  components: { ModelViewVulkan, ModelTree, SelectAction, PlayStepList },
  data() {
    return {
      headerImgs: [
        {
          key: 'left',
          src: require('../images/training_left.png'),
        },
        {
          key: 'center',
          src: require('../images/training_center.png'),
          text: '设备拆解培训',
        },
        {
          key: 'right',
          src: require('../images/training_right.png'),
        },
      ],
      schemeId: '', // 方案id
      steps: [], // 方案列表
      sceneOptions: {
        isEnableGis: '',
        longitude: '',
        latitude: '',
        name: '',
        id: '',
        jsonData: '',
      },
      player: null,
      engineId: '',
      isLoadModelEnd: false,
      showModelTree: false,
      showTagBasicInfo: false,
      schemeDetail: {},
      dirOptions: {
        0: [0, -1, 0],
        1: [0, 1, 0],
        2: [-1, 0, 0],
        3: [1, 0, 0],
        4: [0, 0, 1],
        5: [0, 0, -1],
      },
      playerObj: null,
      showSelect: false,
      showFinish: false,
      showOperateSpeed: true,
      showTips: false,
      operateType: -1,
      stepTimer: null,
      currentStepIndex: -1,
      playSpeed: 1,
      isAssessMode: false,
      isShowMsg: false,
      isOpenStep: false,
      showJump: true,
      fastObj: {
        0.1: 0.2,
        0.2: 0.5,
        0.5: 1,
        1: 2,
        2: 4,
        4: 8,
        8: 16,
      },
      slowObj: {
        0.2: 0.1,
        0.5: 0.2,
        1: 0.5,
        2: 1,
        4: 2,
        8: 4,
        16: 8,
      },
      operateTypeList: ['组装演示', '拆卸演示', '顺序组装', '顺序拆卸', '逻辑组装', '逻辑拆卸'],
      // 考核模式当前的步骤的索引
      assessCurIndex: 0,
      // 考核分数，初始值为100分
      assessScore: 100,
      // 考核模式开始时间
      startTime: '',
      executeStepList: [],
      chooseIndex: '',
      stepNodeObj: {},
      isRun: false,
      // 位号基本信息
      location: {
        height: '35rem',
        top: '130px',
        float: 'right',
      },
      currentCode: '', // 当前点选的code
      nodeInterval: null,
      setNodeInterval: null,
      nodePositionInterval: null,
      currentStep: null,
      msgList: [], // 消息列表
      currentNode: {
        node: null,
        localTrans: [],
      },
      preIsFinish: false,
    }
  },
  computed: {
    cloudRender() {
      return cloudRender
    },
    operateText() {
      if (this.operateType % 2 === 0) {
        return '组装'
      }
      return '拆卸'
    },
    showSpeed() {
      if (this.playSpeed % 1 === 0) {
        return `${this.playSpeed}.0`
      }
      return this.playSpeed
    },
    isShowStep() {
      return this.isAssessMode || this.isShowMsg
    },
    limitedMsgList() {
      let totalRow = 0
      let targetIndex = 0
      this.msgList.slice(-10).map((item, index) => {
        const row = Math.ceil(item.msg.length / 72)
        totalRow += row
        if (totalRow >= 8 && !targetIndex) {
          targetIndex = index
        }
      })
      return this.msgList.slice(-targetIndex)
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (Array.isArray(routerBase)) {
        // 多个微服务场景取第一个基础微服务
        return `/${routerBase[0]}`
      }
      return routerBase ? `/${routerBase}` : ''
    },
    currentUser() {
      return JSON.parse(localStorage.getItem('CurrentUser')) || {}
    },
  },
  watch: {
    'currentNode.localTrans': {
      async handler(val) {
        const currentItem = this.executeStepList.find((item) => {
          return item.node === this.currentNode.node
        })
        if (_.isEmpty(currentItem) || val.length === 0) return
        const srcLocation = currentItem.srcLocation
        const distance = [val[0] - srcLocation[0], val[1] - srcLocation[1], val[2] - srcLocation[2]]
        const euclideanDistance = Math.sqrt(
          distance.reduce((sum, d) => {
            return sum + d * d
          }, 0)
        )
        if (euclideanDistance < 150 && [3, 5].includes(this.operateType)) {
          if (this.nodePositionInterval) clearInterval(this.nodePositionInterval)
          await this.player.Native.Node.setProperty(currentItem.node, {
            localTrans: currentItem.targetLocation,
          })
          this.axisFinish({ type: 1, node: currentItem.node }, currentItem)
        } else if (euclideanDistance < 60) {
          if (this.nodePositionInterval) clearInterval(this.nodePositionInterval)
          this.stopNodeIntervals()
          // 设置位置s
          await this.player.Native.Node.setProperty(currentItem.node, {
            localTrans: currentItem.srcLocation,
          })
          this.axisFinish({ type: 1, node: currentItem.node }, currentItem)
        } else if (euclideanDistance < 100 && this.nodeInterval === null) {
          this.setNodeColor(currentItem.cloneNode)
        }
      },
      deep: true,
    },
  },
  async created() {
    this.schemeId = this.$route.query.id
    // 获取方案详情
    this.schemeDetail = await this.getSchemeDetail()
  },
  methods: {
    /**
     * @description: 设置场景加载的参数
     * @param {*} 场景id
     * @return {*}
     */
    async getSceneDetail(sceneId) {
      const [err, res] = await modelSceneApi.get(sceneId)
      let options = null
      if (!err && !_.isNil(res)) {
        options = _.pick(res, ['isEnableGis', 'latitude', 'longitude', 'name', 'id', 'folderId'])
      }
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id: sceneId })
      if (!jsonErr) {
        options.jsonData = jsonRes
        this.sceneOptions = _.cloneDeep(options)
      }
    },
    // player实例化完成
    sendPlayer(player) {
      this.player = player
    },
    // 模型加载完成
    async loadModelEnd() {
      this.isLoadModelEnd = true
      this.showSelect = true
      this.cloudRender.Dispatch.on('Animation', this.animationCallback)
      // // 编辑轴
      this.player.Native.Node.EventAxisEditStart.connect(this.axisEditStart)
      this.player.Native.Node.EventAxisEditFinish.connect(this.axisEditEnd)
    },
    async getSchemeDetail() {
      const [err, res] = await equipDisAssembleySolution.get(this.schemeId)
      if (!err && !_.isNil(res)) {
        this.steps = _.map(res.steps, (el) => {
          return {
            ...el,
            targetLocation: el.targetLocation.split(',').map((item) => {
              return Number(item)
            }),
            srcLocation: el.srcLocation.split(',').map((item) => {
              return Number(item)
            }),
          }
        })
        this.getSceneDetail(res.modelId)
        return res
      }
      return {}
    },
    // 执行方案
    async executeScheme(params) {
      if (this.steps.length === 0) return
      this.operateType = params[0]
      this.addMsg('', '', 'msg', 'start')
      this.chooseIndex = ''
      this.isAssessMode = params[2]
      if (this.isAssessMode) {
        this.startTime = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      this.isShowMsg = params[1]
      // 如果展示步骤列表
      if (this.isShowStep) {
        // 列表默认展示步骤跳转
        this.showJump = true
        // 重置执行步骤索引
        this.currentStepIndex = -1
      }
      this.executeStepList =
        this.executeStepList.length > 0 ? this.executeStepList : _.cloneDeep(this.steps)
      // 拿到节点数组
      const root = await this.player.Native.Node.getRoot()
      const nodes = await this.player.Native.Node.findNode(root, {
        names: this.executeStepList.map((item) => {
          return item.nodeName
        }),
      })
      if (!_.isEmpty(nodes) && nodes.names) {
        for (let i = 0; i < this.executeStepList.length; i++) {
          const element = this.executeStepList[i]
          if (!nodes.names[element.nodeName]) continue
          this.executeStepList[i].node = nodes.names[element.nodeName]?.node
          if (!this.executeStepList[i].cloneNode) {
            this.executeStepList[i].cloneNode = await this.player.Native.Node.clone(
              this.executeStepList[i].node
            )
            await this.player.Native.Node.addToFactory([element.cloneNode])
          }
          const nodeInfo = await this.player.Native.Node.getProperty(this.executeStepList[i].node, [
            'parent',
            'code',
          ])
          // 设置位置
          await this.player.Native.Node.setProperty(element.cloneNode, {
            localTrans:
              this.operateType % 2 === 0
                ? this.executeStepList[i].srcLocation
                : this.executeStepList[i].targetLocation,
            name: `${element.name}_Clone`,
            parent: nodeInfo.parent,
            visible: false,
          })
          await this.player.Native.Node.setProperty(element.node, {
            localTrans:
              this.operateType % 2 === 0
                ? this.executeStepList[i].targetLocation
                : this.executeStepList[i].srcLocation,
          })
          this.executeStepList[i].cloneName = `${element.name}_Clone`
          this.executeStepList[i].code = nodeInfo.code
        }
        this.currentStepIndex = this.operateType % 2 === 0 ? this.executeStepList.length - 1 : 0
        this.currentStep = this.executeStepList[this.currentStepIndex]
        if (this.operateType === 0 || this.operateType === 1) {
          // 加载动画
          await this.loadAnimation(this.executeStepList, this.operateType)
          await this.startAnimation(this.executeStepList[this.currentStepIndex])
          this.isRun = true
          this.showOperateSpeed = true
        }
        if (this.operateType === 2 || this.operateType === 3) {
          this.addMsg(
            this.currentStep.name,
            this.currentStep.code,
            'msg',
            `${this.currentStep.name}_start`
          )
        }
        this.showTips = true
      }
    },
    async loadAnimation(stepList, type) {
      for (let i = 0; i < stepList.length; i++) {
        const element = stepList[i]
        // 巡检数据
        const keyframeData = this.getKeyframeData(
          type === 0 ? element.targetLocation : element.srcLocation,
          type === 0 ? element.srcLocation : element.targetLocation,
          element
        )
        this.executeStepList[i].animationTime = keyframeData[keyframeData.length - 1].time
        // 轨道数据
        const track = [
          {
            name: element.name,
            trackType: 3,
            propertyLinkType: 1,
            interpolationType: 0,
          },
        ]
        const codeInfoRes = await this.cloudRender.NodeProxy.findNode('names', element.nodeName)
        // 动画参数
        const nodeAnimationParam = [
          {
            keyframeData: [keyframeData],
            track,
            node: codeInfoRes.data[0],
          },
        ]
        // 加载动画
        await this.cloudRender.Animation.loadAnimation(element.nodeName, nodeAnimationParam, {
          autoPlay: false,
          bindUpdate: true,
          loopType: 0,
        })
      }
    },
    // 获取关键帧数据
    getKeyframeData(startP, endP, data) {
      const keyframeData = []
      keyframeData.push({
        point: startP,
        time: 0,
      })
      let intermediatePoint = [...startP] // 中间点
      if (['上', '右', '前'].includes(data.disAssembleyDiretionTypeString)) {
        intermediatePoint = [
          data.disAssembleyDiretionTypeString === '右'
            ? parseFloat(startP[0]) + parseFloat(data.moveDistance)
            : parseFloat(startP[0]),
          data.disAssembleyDiretionTypeString === '前'
            ? parseFloat(startP[1]) + parseFloat(data.moveDistance)
            : parseFloat(startP[1]),
          data.disAssembleyDiretionTypeString === '上'
            ? parseFloat(startP[2]) + parseFloat(data.moveDistance)
            : parseFloat(startP[2]),
        ]
      } else if (['左', '后', '下'].includes(data.disAssembleyDiretionTypeString)) {
        intermediatePoint = [
          data.disAssembleyDiretionTypeString === '左'
            ? parseFloat(startP[0]) - parseFloat(data.moveDistance)
            : parseFloat(startP[0]),
          data.disAssembleyDiretionTypeString === '后'
            ? parseFloat(startP[1]) - parseFloat(data.moveDistance)
            : parseFloat(startP[1]),
          data.disAssembleyDiretionTypeString === '下'
            ? parseFloat(startP[2]) - parseFloat(data.moveDistance)
            : parseFloat(startP[2]),
        ]
      }
      const distanceToIntermediate = Math.sqrt(
        Math.pow(intermediatePoint[0] - startP[0], 2) +
          Math.pow(intermediatePoint[1] - startP[1], 2) +
          Math.pow(intermediatePoint[2] - startP[2], 2)
      )
      const timeToIntermediate = distanceToIntermediate / parseFloat(data.speed)
      keyframeData.push({
        point: intermediatePoint,
        time: timeToIntermediate,
      })
      const distanceToEnd = Math.sqrt(
        Math.pow(endP[0] - intermediatePoint[0], 2) +
          Math.pow(endP[1] - intermediatePoint[1], 2) +
          Math.pow(endP[2] - intermediatePoint[2], 2)
      )
      const timeToEnd = timeToIntermediate + distanceToEnd / parseFloat(data.speed)
      keyframeData.push({
        point: endP,
        time: timeToEnd + timeToIntermediate,
      })
      return keyframeData
    },
    async startAnimation(animationData) {
      this.addMsg(animationData.name, animationData.code, 'msg', `${animationData.name}_start`)
      this.currentStep = animationData
      await this.cloudRender.Animation.setAnimationSpeed(
        animationData.nodeName,
        this.playSpeed || animationData.speed
      )
      await this.cloudRender.Animation.setAnimationStatus(animationData.nodeName, true)
      this.setNodeColor(animationData.cloneNode)
    },
    setNodeColor(node) {
      this.nodeInterval = setInterval(async () => {
        await this.player.Native.Node.setProperty(node, {
          visible: false,
          colorIndex: 0,
        })
      }, 200)
      this.setNodeInterval = setInterval(async () => {
        await this.player.Native.Node.setProperty(node, {
          visible: true,
          colorIndex: 77,
        })
      }, 400)
    },
    async animationCallback(event) {
      if (event.type === 1 && event?.actionState === 2) {
        this.stopNodeIntervals()
        await this.player.Native.Node.setProperty(this.currentStep?.cloneNode, {
          visible: true,
          colorIndex: 0,
        })
        const msgData = this.msgList[this.msgList.length - 1]
        if (
          `${event.animateId}_end` !== msgData.code &&
          msgData.code !== 'end' &&
          !msgData.code.includes('jump')
        ) {
          this.addMsg(
            this.currentStep.name,
            this.currentStep.code,
            'msg',
            `${this.currentStep.name}_end`
          )
        }

        if (
          (this.operateType === 0 && this.currentStepIndex > 0) ||
          (this.operateType === 1 && this.currentStepIndex < this.executeStepList.length - 1)
        ) {
          this.currentStepIndex =
            this.operateType === 0 ? this.currentStepIndex - 1 : this.currentStepIndex + 1
          await this.startAnimation(this.executeStepList[this.currentStepIndex])
          return
        }
        if (
          this.currentStepIndex === 0 ||
          this.currentStepIndex === this.executeStepList.length - 1
        ) {
          this.showFinish = true
          this.showOperateSpeed = false
          this.isRun = false
          window.speechSynthesis.cancel()
          if (this.isShowStep) {
            // 结束后不可跳转
            this.showJump = false
          }
          if (`${event.animateId}_end` !== msgData.code) {
            this.addMsg('', '', 'msg', 'end')
          }
        }
      }
    },
    needWatchP(node) {
      if (
        this.executeStepList.filter((item) => {
          return item.node === node
        }).length === 0
      ) {
        return false
      }
      if (this.currentStep.node !== this.currentNode.node && [2, 3].includes(this.operateType)) {
        return false
      }
      if ([4, 5].includes(this.operateType)) {
        // 判断前置条件是否完成
        const currentItem = this.executeStepList.find((item) => {
          return item.node === node
        })
        const precondition = this.executeStepList.find((item) => {
          return this.operateType === 4
            ? item.nodeName === currentItem.assembleyCondition
            : item.nodeName === currentItem.disAssembleyCondition
        })
        if (
          currentItem.isFinish ||
          (this.operateType === 4 && currentItem.assembleyCondition && !precondition.isFinish) ||
          (this.operateType === 5 && currentItem.disAssembleyCondition && !precondition.isFinish)
        ) {
          return false
        }
      }
      return true
    },
    // 编辑轴操作回调
    axisEditStart(data) {
      // 需要实时监听节点位置
      const needWatchP = this.needWatchP(data.node)
      if (!needWatchP) return
      if (this.nodePositionInterval) clearInterval(this.nodePositionInterval)
      this.nodePositionInterval = setInterval(async () => {
        if (this.currentNode.node) {
          const nodeInfo = await this.player.Native.Node.getProperty(this.currentNode.node, [
            'localTrans',
          ])
          this.currentNode.localTrans = nodeInfo.localTrans
        }
      }, 200)
    },
    async axisEditEnd(data) {
      if (this.nodePositionInterval) clearInterval(this.nodePositionInterval)
      const stepItem = this.executeStepList.find((item) => {
        return item.node === data.node
      })
      if (_.isEmpty(stepItem) && [4, 5].includes(this.operateType)) return
      if (
        (this.currentStep?.node !== data.node && [2, 3].includes(this.operateType)) ||
        (!_.isEmpty(stepItem) && [4, 5].includes(this.operateType))
      ) {
        const index = this.executeStepList.findIndex((item) => {
          return item.node === data.node
        })
        const msgData = [2, 3].includes(this.operateType)
          ? this.msgList[this.msgList.length - 2]
          : this.msgList[this.msgList.length - 1]
        if (!_.isEmpty(stepItem) && msgData?.type?.includes('success') && this.preIsFinish) {
          await this.player.Native.Node.setProperty(data.node, {
            localTrans: this.operateType % 2 === 0 ? stepItem.srcLocation : stepItem.targetLocation,
          })
          this.preIsFinish = false
          return
        }
        if (!_.isEmpty(stepItem) && !stepItem.isFinish && [2, 3].includes(this.operateType)) {
          await this.player.Native.Node.setProperty(data.node, {
            localTrans: this.operateType % 2 === 0 ? stepItem.targetLocation : stepItem.srcLocation,
          })
        }
        if ([4, 5].includes(this.operateType) && !stepItem.isFinish) {
          // 判断有没有前置条件
          if (
            (!stepItem.assembleyCondition && this.operateType === 4) ||
            (!stepItem.disAssembleyCondition && this.operateType === 5)
          ) {
            this.addMsg(stepItem.name, stepItem.code, 'warn', `${stepItem.name}_warn`, index)
            return
          }
          const type = this.operateType === 4 ? 'assembleyCondition' : 'disAssembleyCondition'
          const precondition = this.executeStepList.find((item) => {
            return item.nodeName === stepItem[type]
          })
          if (precondition && !precondition.isFinish) {
            await this.player.Native.Node.setProperty(data.node, {
              localTrans:
                this.operateType % 2 === 0 ? stepItem.targetLocation : stepItem.srcLocation,
            })
            this.addMsg(precondition.name, '', 'warn', 'errorPreObj', index)
            return
          }
          if (precondition.isFinish) {
            this.addMsg(stepItem.name, stepItem.code, 'warn', `${stepItem.name}_warn`, index)
            return
          }
        }
        if (
          this.executeStepList.every((item) => {
            return item.isFinish
          })
        ) {
          return
        }
        this.addMsg('', '', 'warn', 'error', index)
        return
      }
      this.addMsg(
        this.currentStep.name,
        this.currentStep.code,
        'warn',
        `${this.currentStep.name}_warn`,
        this.currentStepIndex
      )
    },
    async axisFinish(data, currentItem) {
      if (this.nodePositionInterval) clearInterval(this.nodePositionInterval)
      if (data?.type === 1) {
        this.preIsFinish = true
        await this.player.Native.Node.setProperty(currentItem.cloneNode, {
          visible: false,
          colorIndex: 0,
        })
        this.addMsg(currentItem.name, currentItem.code, 'success', `${currentItem.name}_end`)
        this.executeStepList.forEach((item) => {
          if (item.node === currentItem.node) item.isFinish = true
        })
        this.currentStepIndex =
          this.operateType % 2 === 0 ? this.currentStepIndex - 1 : this.currentStepIndex + 1
        this.currentStep = this.executeStepList[this.currentStepIndex]
        if (
          (this.operateType % 2 === 0 && this.currentStepIndex < 0) ||
          (this.operateType % 2 === 1 && this.currentStepIndex >= this.executeStepList.length)
        ) {
          this.msgList.push({
            code: 'end',
            type: 'msg',
            msg: `[消息]:设备${this.operateTypeList[this.operateType]}：学习完成!`,
          })
          setTimeout(async () => {
            await this.player.Native.Node.removeNodeFromAxisEdit(data.node)
            this.showFinish = true
            window.speechSynthesis.cancel()
          }, 1500)
          // 统计分数
          if (this.isAssessMode && (this.operateType !== 0 || this.operateType !== 1)) {
            this.msgList.forEach((element) => {
              if (element.type === 'warn') {
                this.assessScore -= Number(this.executeStepList[element.stepIndex]?.grade) || 0
              }
            })
            this.addGrade()
          }
          return
        }
        if ([4, 5].includes(this.operateType)) return
        this.addMsg(currentItem.name, currentItem.code, 'msg', `${currentItem.name}_start`)
      }
    },
    // 监听模型点选
    async modelClick(val) {
      const nodeInfo = await this.player.Native.Node.getProperty(val.node, ['code'])
      // 点击时间通知到位号基础属性
      this.currentCode = nodeInfo.code
      if ([2, 3, 4, 5].includes(this.operateType)) {
        await this.player.Native.Node.removeNodeFromAxisEdit(this.currentNode.node)
        await this.player.Native.Node.addNodeToAxisEdit(val.node)
        await this.player.Native.Node.setAxisEditType(1)
      }
      this.currentNode.node = val.node
    },
    // 再次操作
    operateAgain() {
      this.showFinish = false
      this.showSelect = true
      this.isAssessMode = false
      this.isShowMsg = true
      this.$refs.stepRef.chooseIndex = -1
      this.showTips = false
      this.playSpeed = 1
      this.msgList = []
      this.assessCurIndex = 0
      this.startTime = ''
      this.currentNode = {
        node: null,
        localTrans: [],
      }
      this.currentStep = null
      this.currentCode = ''
      this.executeStepList.forEach((item) => {
        item.isFinish = false
      })
    },
    // 控制速度
    async operateSpeed(type) {
      switch (type) {
        case 'pause':
          await this.cloudRender.Animation.setAnimationStatus(this.currentStep?.nodeName, false)
          this.stopNodeIntervals()
          if (!window.speechSynthesis.paused) {
            window.speechSynthesis.pause()
          }
          break
        case 'play':
          this.stopNodeIntervals()
          await this.startAnimation(this.currentStep)
          if (window.speechSynthesis.paused) {
            window.speechSynthesis.resume()
          }
          break
        case 'fast':
          if (this.playSpeed <= 8) {
            this.playSpeed = this.fastObj[this.playSpeed]
            await this.cloudRender.Animation.setAnimationSpeed(
              this.currentStep?.nodeName,
              this.playSpeed * 2
            )
          }
          break
        case 'slow':
          if (this.playSpeed >= 0.2) {
            this.playSpeed = this.slowObj[this.playSpeed]
            await this.cloudRender.Animation.setAnimationSpeed(
              this.currentStep?.nodeName,
              this.playSpeed / 2
            )
          }
          break
        default:
          this.playSpeed = 1
          await this.cloudRender.Animation.setAnimationSpeed(
            this.currentStep?.nodeName,
            this.playSpeed
          )
          break
      }
    },
    // 添加成绩
    async addGrade() {
      const durationSeconds = moment(new Date()).diff(this.startTime, 'seconds')
      const hours = Math.floor(durationSeconds / 3600)
      const minutes = Math.floor(Math.floor(durationSeconds / 60) % 60)
      const seconds = durationSeconds % 60
      const durationStr =
        (hours > 0 ? `${hours}h` : '') +
        (minutes > 0 ? `${minutes}m` : '') +
        (seconds > 0 ? `${seconds}s` : '')
      const res = await equipDisAssembleyLearnRecord.create({
        body: {
          siteId: null,
          startTime: this.startTime,
          duration: durationStr,
          grade: this.assessScore > 0 ? this.assessScore : 0,
          disAssembleyOperationType: this.operateType,
          disAssembleyTestType: this.isShowMsg ? 0 : 1,
          solutionId: this.schemeDetail.id,
          learningUserName: this.currentUser.Name || '超级管理员',
          learningUserId: this.currentUser.UserId || 'c74d669c-a3d4-11e5-b60d-b870f43edd03',
        },
      })
    },
    // 返回
    goBack() {
      this.stopNodeIntervals()
      this.$router.push(`${this.basePath}/equipment-disassemble-training/list`)
    },
    // 步骤跳转
    async stepJump(chooseIndex) {
      this.chooseIndex = chooseIndex
      this.operateSpeed('pause')
      if (this.operateType % 2 === 0) {
        await Promise.all(
          this.executeStepList.map(async (item, index) => {
            item.isFinish = index > chooseIndex
            if (index <= chooseIndex) {
              // 没有组装的步骤
              if (this.operateType === 0) {
                await this.cloudRender.Animation.setAnimationStatus(item.nodeName, false)
                await this.cloudRender.Animation.setAnimationTime(item.nodeName, 0)
              }
              await this.player.Native.Node.setProperty(item.node, {
                localTrans: item.targetLocation,
              })
              await this.player.Native.Node.setProperty(item.cloneNode, {
                visible: false,
              })
              this.addMsg(item.name, item.code, 'msg', `${item.name}_jump`)
            } else {
              // 结束的部分
              await this.player.Native.Node.setProperty(item.node, {
                localTrans: item.srcLocation,
              })
              await this.player.Native.Node.setProperty(item.cloneNode, {
                visible: false,
              })
              this.addMsg(item.name, item.code, 'msg', `${item.name}_jump`)
            }
          })
        )
      } else {
        await Promise.all(
          this.executeStepList.map(async (item, index) => {
            item.isFinish = index < chooseIndex
            if (index >= chooseIndex) {
              // 没拆卸的步骤
              if (this.operateType === 1) {
                await this.cloudRender.Animation.setAnimationStatus(item.nodeName, false)
                await this.cloudRender.Animation.setAnimationTime(item.nodeName, 0)
              }
              await this.player.Native.Node.setProperty(item.node, {
                localTrans: item.srcLocation,
              })
              await this.player.Native.Node.setProperty(item.cloneNode, {
                visible: false,
              })
              this.addMsg(item.name, item.code, 'msg', `${item.name}_jump`)
            } else {
              // 拆卸完成
              await this.player.Native.Node.setProperty(item.node, {
                localTrans: item.targetLocation,
              })
              await this.player.Native.Node.setProperty(item.cloneNode, {
                visible: false,
              })
              this.addMsg(item.name, item.code, 'msg', `${item.name}_jump`)
            }
          })
        )
      }
      this.currentStepIndex = chooseIndex
      this.currentStep = this.executeStepList[chooseIndex]
      if ([0, 1].includes(this.operateType)) {
        await this.startAnimation(this.currentStep)
      }
      if ([2, 3, 4, 5].includes(this.operateType)) {
        if ([2, 3].includes(this.operateType)) {
          this.addMsg(
            this.currentStep.name,
            this.currentStep.code,
            'msg',
            `${this.currentStep.name}_start`
          )
        }
        this.modelClick({ node: this.currentStep.node })
      }
    },
    // 停止定时器
    stopNodeIntervals() {
      if (this.nodeInterval) {
        clearInterval(this.nodeInterval)
        this.nodeInterval = null
      }
      if (this.setNodeInterval) {
        clearInterval(this.setNodeInterval)
        this.setNodeInterval = null
      }
    },
    addMsg(name = '', code = '', type = 'msg', mapCode, stepIndex = '') {
      const msg = {
        start: `[消息]:设备${this.operateTypeList[this.operateType]}：开始..`,
        [`${name}_start`]: `[消息]:设备${
          this.operateTypeList[this.operateType]
        }：Name：${name},Code：${code}步骤开始`,
        [`${name}_end`]: `[消息]:设备${
          this.operateTypeList[this.operateType]
        }：Name：${name},Code：${code}步骤完成`,
        end: `[消息]:设备${this.operateTypeList[this.operateType]}完成`,
        error: `[错误]:设备${this.operateTypeList[this.operateType]}：操作对象错误`,
        [`${name}_warn`]: `[错误]:设备${
          this.operateTypeList[this.operateType]
        }：Name: [${name}], Code:[${code}]安装位置错误!`,
        [`${name}_jump`]: `[消息]:设备${
          this.operateTypeList[this.operateType]
        }：Name：${name},Code：${code}步骤跳转`,
        errorPreObj: `[错误]:设备${
          this.operateTypeList[this.operateType]
        }：请先完成前置步骤${name}`,
      }
      this.msgList.push({
        code: mapCode,
        type,
        msg: msg[mapCode],
        stepIndex,
      })
    },
  },
  beforeDestroy() {
    this.stopNodeIntervals()
    if (this.cloudRender && this.player) {
      this.cloudRender.Dispatch.off('Animation', this.animationCallback)
      this.cloudRender.Engine.destroyEngine()
      this.player.Native.Node.EventAxisEditStart.disconnect(this.axisEditStart)
      this.player.Native.Node.EventAxisEditFinish.disconnect(this.axisEditEnd)
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../css/index';
.h-200px {
  height: 200px !important;
}
.h-35px {
  height: 35px !important;
}
.model-tree {
  left: 10px;
  top: 40px;
  height: calc(100% - 60px) !important;
  width: 400px;
  z-index: 99;
  padding: 10px;
  color: #fff !important;
  background-color: #2e6bb07f !important;
  border: none !important;
}
.training-header {
  height: 80px !important;
  .header-text {
    transform: translate(-50%, -50%) !important;
  }
}
.left-control {
  top: 90px;
  left: 0px;
  z-index: 99;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  height: 36px !important;
  width: 32px;
  background-image: url('../images/Vector-1.png');
  background-color: #197cc6 !important;
  background-position: center;
  background-repeat: no-repeat;
  &.openTree {
    left: 410px;
    background-image: url('../images/Vector.png');
  }
}
.right-control {
  top: 90px;
  right: 0px;
  z-index: 99;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  cursor: pointer;
  height: 36px !important;
  width: 32px;
  background-image: url('../images/Vector.png');
  background-color: #197cc6 !important;
  background-position: center;
  background-repeat: no-repeat;
  &.openStep {
    right: 410px;
    background-image: url('../images/Vector-1.png');
  }
}
.right-control1 {
  top: 130px;
  &.openStep {
    right: 378px;
    background-image: url('../images/Vector-1.png');
  }
}
.tips {
  top: 30px;
  left: 170px;
  z-index: 1;
  border-radius: 4px;
  width: 300px;
  padding: 10px;
  height: 100px !important;
  background-color: #2e6bb07f !important;
  .tips-content {
    width: 100%;
    height: 100% !important;
    padding: 15px;
    background-color: rgba($color: #275182, $alpha: 0.8) !important;
    .scheme-name {
      overflow: hidden;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: white !important;
    }
  }
}
.btn {
  text-align: center;
  color: #fff !important;
  background: url('../images/button.png') no-repeat !important;
  padding: 0px !important;
  line-height: 30px !important;
  background-size: 100% 100% !important;
}
.operate-button {
  top: 100px;
  left: 50%;
  transform: translateX(-50%) !important;
  z-index: 999;
  align-items: center;
  justify-content: space-around;
  width: 450px;
  height: 80px !important;
  border-radius: 40px;
  background-color: #1842727f !important;
  div {
    height: 47px !important;
    width: 47px;
    cursor: pointer;
    &.speed {
      align-items: center;
      justify-content: space-around;
      background-color: #07203d7f;
      cursor: default;
    }
    &.play {
      background-image: url('../images/play.png');
      &.choosed,
      &:hover {
        background-image: url('../images/play_choosed.png');
      }
    }
    &.pause {
      background-image: url('../images/pause.png');
      &.choosed,
      &:hover {
        background-image: url('../images/pause_choosed.png');
      }
    }
    &.fast {
      background-image: url('../images/fastForward.png');
      &.choosed,
      &:hover {
        background-image: url('../images/fastForward_choosed.png');
      }
    }
    &.slow {
      background-image: url('../images/slowDown.png');
      &.choosed,
      &:hover {
        background-image: url('../images/slowDown_choosed.png');
      }
    }
    &.reset {
      background-image: url('../images/reset.png');
      &.choosed,
      &:hover {
        background-image: url('../images/reset_choosed.png');
      }
    }
  }
}
.finish-mask {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba($color: #000, $alpha: 0.5);
  .finish {
    width: 460px;
    height: 320px !important;
    top: 50%;
    left: 50%;
    z-index: 999;
    transform: translate(-50%, -50%) !important;
    background-image: url('../images/dialog3.png');
    .finish-title {
      font-weight: bold;
      background-image: -webkit-repeating-linear-gradient(top, #fff, #ebeff3, #409bf1);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      letter-spacing: 3px;
    }
    .content {
      height: 110px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #92b5cd;
      letter-spacing: 3px;
    }
    .operate {
      ::v-deep .el-button {
        background-color: #00c0ff !important;
        width: 100px;
      }
    }
  }
}
.info {
  z-index: 999;
  color: #4e6b93;
  letter-spacing: 2px;
  width: 100%;
  bottom: 15px;
}
/* 定义闪烁动画 */
@keyframes flash {
  0%,
  100% {
    color: red;
  }
  50% {
    color: black;
  }
}

.flash-message {
  animation: flash 1s infinite;
}
@keyframes flash-warn {
  0%,
  100% {
    color: red;
  }
  50% {
    color: rgb(221, 255, 28);
  }
}

.flash-warn {
  animation: flash-warn 1s infinite;
}
</style>
